import Operation from './Operation.js';
import DeleteSelection from './DeleteSelection.js';
import InsertRollEvent from './InsertRollEvent.js';
import {deletePatternsSelection} from './deletePatternsSelection.js';
import GenericSelection from './GenericSelection.js';
import InsertEvent from './InsertEvent.js';
import {
    constructEvent,
    NO_SUB_SEQUENCE,
    SEQUENCE_ROLL} from 'session/constants.js';

const DETERMINISTIC = 'DETERMINISTIC';
const LINEAR = 'LINEAR';
const BASIC = 'BASIC';

class PasteSelection extends GenericSelection {
    constructor(mix, step, selection, mixType, track) {
        super(mix, step, selection, mixType);
        this.track = track;
    }

    executeByType(eventType, mixByType, mixType) {
        let events = mixByType.getEventsBetween(this.start, this.end, true);

        let copiedEvents = events
            .filter(x => !x.isPrunable())
            .map(e => {
                let copied = e.getCopy(this.mix.sequencerEngine);
                copied.setTime(undefined, this.step + e.step - this.start);

                if (copied.subEvents) {
                    copied.subEvents.forEach(s => s.step = this.step + s.step - this.start);
                }
                copied.duration = e.duration;
                copied.subSequence = this.mix.subSequence;
                return copied;
        });

        if (mixByType.getMixType() === DETERMINISTIC) {
            let edgeEvent = mixByType.getEvent(this.start, false).getCopy(
                this.mix.sequencerEngine);
            if (!edgeEvent.isPrunable()) {
                edgeEvent.setTime(undefined, this.step);
                copiedEvents.push(edgeEvent);
            }
        }

        if (mixByType.getMixType() === LINEAR) {
            let startEvent = constructEvent(eventType);
            if (startEvent !== undefined) {
                let startValue= mixByType.getValueAtStep(this.start);
                let endValue = mixByType.getValueAtStep(this.end - 1);
                startEvent.setValue(startValue);
                startEvent.setTime(undefined, this.step);
                startEvent.subSequence = this.mix.subSequence;
                    
                let endEvent = constructEvent(eventType);
                endEvent.setValue(endValue);
                endEvent.setTime(undefined, this.step + this.end - this.start - 1);
                endEvent.subSequence = this.mix.subSequence;

                let previousEndEvent = constructEvent(eventType);
                previousEndEvent.setValue(endValue);
                previousEndEvent.setTime(undefined, this.step - 1);
                previousEndEvent.subSequence = this.mix.subSequence;

                copiedEvents.push(startEvent);
                copiedEvents.push(endEvent);
                copiedEvents.push(previousEndEvent);
            }
        }

        for (let i in copiedEvents) {
            let event = copiedEvents[i];
            if (eventType === SEQUENCE_ROLL) {
                new InsertRollEvent(this.mix, event, event.duration)
                    .execute();
            } else {
                new InsertEvent(this.mix, event, event.duration)
                    .execute();
            }
        }
    }

    async executeForTrack(track) {
        let patternsToPaste = [];
        let start = Infinity;
        let end = -Infinity;
        for (let i in track.patterns) {
            let pattern = track.patterns[i];
            if ((pattern.startStep >= this.start && pattern.startStep < this.end) ||
                (pattern.endStep >= this.start && pattern.endStep < this.end)) {
               let copiedPattern = undefined;
                if (pattern.startStep < this.start) {
                    let _start = this.start - pattern.startStep;
                    copiedPattern = await pattern.getCopy(_start, _start +  pattern.endStep - this.start);
                } else if (pattern.endStep > this.end) {
                    copiedPattern = await pattern.getCopy(0, this.end - pattern.startStep);
                } else {
                    copiedPattern = await pattern.getCopy();
                }

                if (copiedPattern.startStep < start) {
                    start = copiedPattern.startStep;
                }
                if (copiedPattern.endStep  > end) {
                    end = copiedPattern.endStep;
                }

                copiedPattern.track = this.track;
                let offset = copiedPattern.startStep - this.start;
                copiedPattern.startStep = this.step + offset;
                patternsToPaste.push(copiedPattern);
            }
        }

        if (start !== Infinity && end !== -Infinity) {
            deletePatternsSelection(
                this.track,
                this.step + start - this.start,
                this.step + end - this.start);
        }

        this.track.patterns = [... this.track.patterns, ...patternsToPaste];
        this.track.updateSteps();
    }
}

export default PasteSelection;
